// extracted by mini-css-extract-plugin
export default {"button-container":"AddAQuestion_button-container__ABZFa","add-question-container":"AddAQuestion_add-question-container__2kXW9"};